// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QznH","questions":"styles_questions__3IwMq","footer":"styles_footer__Soszo"};